import { plural } from '@cian/utils';

import { ERailwayTravelType, IOfferRailway } from 'shared/types/offers';

const TIME: [string, string, string] = ['минута', 'минуты', 'минут'];

export const getRailwaysTimeToGet = (railway: IOfferRailway): string => {
  const { time, travelType } = railway;
  if (time == null) {
    return '';
  }

  const text = `${travelType === ERailwayTravelType.ByFoot ? 'пешком' : 'на машине'}`;

  return time > 0 ? `${time}\u00A0${plural(time, TIME)}\u00A0${text}` : `\x031\u00A0минуты\u00A0${text}`;
};
